import { CategoryRolesStrip } from '@/features/home/components/CategoryRolesStrip';
import { NewsTicker } from '@/features/home/components/NewsTicker';

type Props = {
  children: React.ReactNode;
};

/**
 * Shared second-page chrome for role/category cabinets (Task 14):
 * Срочно → Категории/Роли → cabinet body.
 * Mounted only via AppLayout when `isWorkspaceCabinetPath` — never on home.
 */
export const RoleCabinetChrome = ({ children }: Props) => (
  <div className="role-cabinet-chrome">
    <NewsTicker />
    <CategoryRolesStrip />
    {children}
  </div>
);
